import { styled } from "styled-components";
import { Icon } from "@wayflyer/flyui";
import { IconFastArrowRight24Line, IconFastArrowUp24Line, IconXmark24Line } from "@wayflyer/flyui-icons/24/line";

export const CollapseIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  margin-right: -10px;
  justify-content: space-between;
  p {
    margin-top: 0;
  }
`;
const StyledCollapseIcon = styled(IconXmark24Line)`
  margin-top: 3px;
  cursor: pointer;
`;

export const CollapseIcon = ({ size = 16, ...rest }: { size?: number } & { [key: string]: any }) => (
  <Icon size={size} {...rest}>
    <StyledCollapseIcon />
  </Icon>
);

export const ExpandIconContainer = styled.div<{ isBottom: boolean }>`
  margin-top: ${(props) => (props.isBottom ? "0" : "10px")};
  margin-bottom: ${(props) => (props.isBottom ? "10px" : "0")};
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    margin-top: 10px;
    margin-bottom: 0;
  }
`;

const StyledExpandIcon = styled(IconFastArrowRight24Line)`
  cursor: pointer;
`;

export const ExpandIcon = ({ size = 16 }: { size?: number }) => (
  <Icon color="info" size={size}>
    <StyledExpandIcon />
  </Icon>
);

const StyledExpandIconMobile = styled(IconFastArrowUp24Line)`
  cursor: pointer;
`;

export const ExpandIconMobile = ({ size = 16 }: { size?: number }) => (
  <Icon color="info" size={size}>
    <StyledExpandIconMobile />
  </Icon>
);

export const CollapsedContainer = styled.div`
  max-width: 60px;
  max-height: 520px;
  display: flex;
  flex-direction: column;
  border-radius: var(--sizes-radius-md);
  border: solid 1px var(--palette-border-neutral-subtle);
  padding: 0 10px;
  @media (max-width: 768px) {
    margin: 0 20px;
    max-width: 100%;
    max-height: 60px;
    flex-direction: row;
  }
`;

export const CollapsedValuesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;
  @media (max-width: 768px) {
    flex-direction: row;
    width: 100%;
  }
`;

export const CollapsedValuesItemContainer = styled.div`
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    writing-mode: horizontal-tb;
    flex-direction: column-reverse;
    transform: rotate(0deg);
  }
`;

export const CollapsedValuesItemTitle = styled.div`
  font-size: 10px;
  color: var(--palette-content-neutral-strong);
  border-left: 1px solid var(--palette-border-neutral-subtle);
  @media (max-width: 768px) {
    border-left: 0;
    border-bottom: 1px solid var(--palette-border-neutral-subtle);
  }
`;

export const CollapsedValuesItemValue = styled.div`
  font-size: 12px;
  color: var(--palette-content-neutral-strong);
`;

export const FormContainer = styled.div`
  box-sizing: content-box;
  width: 420px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const UncollapsedContainer = styled.div`
  box-sizing: content-box;
  max-width: 170px;
  display: flex;
  border-radius: var(--sizes-radius-md);
  border: solid 1px var(--palette-border-neutral-subtle);
  padding: 0 20px 20px;
  @media (max-width: 768px) {
    margin: 0 20px;
    max-width: 100%;
  }
`;
